import styles from "./styles.module.scss";
import Details from "../../../custom/details/details";
import DownloadFile from "../../../custom/downloadFile/downloadFile";
import { useMutation, useQuery } from "@tanstack/react-query";
import { UploadType, getCorporateUploads, updateCorporateUploads } from "../../../requests";
import { useAtomValue } from "jotai";
import { isUpdateCorporateProfile, userProfile } from "../../../state";
import { App, Spin } from "antd";
import { AxiosError } from "axios";
import { useState } from "react";
import { errorMessage } from "../../../utils/errorMessage";

type FileUploads = {
  [key in UploadType]: string;
};

const DocumentUpload = () => {
  const { notification } = App.useApp();
  const profile = useAtomValue(userProfile);
  const isProfileEditable = useAtomValue(isUpdateCorporateProfile);
  const [currentFile, setCurrentFile] = useState('');
  const [files, setFiles] = useState<FileUploads>({
    Profile: "",
    CAC: "",
    Financial: "",
  })

  const updateDocumentMutation = useMutation({mutationFn: updateCorporateUploads})
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["get-corporate-uploads"],
    queryFn: () => getCorporateUploads(profile?.MembershipNo!),
  });

  const uploadData = data?.Data?.CorporateUpload as CorporateUpload[];

  const financial = uploadData?.find(
    (x) => x.UploadType === UploadType.Financial
  );
  const cac = uploadData?.find((x) => x.UploadType === UploadType.Cac);
  const profileUpload = uploadData?.find(
    (x) => x.UploadType === UploadType.Profile
  );

  const handleUpdate = async (file: File, fileType: UploadType) => {
    try {
      const payload = new FormData();
      payload.append("MembershipNo", profile?.MembershipNo);
      payload.append("UploadType", fileType);
      if (file) {
        payload.append("File", file)
      }
      await updateDocumentMutation.mutateAsync(payload, {
        onSuccess: () => {
          notification.success({
            message: "Success",
            description: `${fileType} document updated successfully`,
          });
          refetch();
          setFiles((prevState) => ({...prevState, [fileType]: "" }));
        },
      });
    }
    catch (error: any) {
      notification.error({
        message: "Error",
        description: errorMessage(error),
      })
    }
  }

  if (isLoading)
    return <Spin style={{ justifySelf: "center", alignSelf: "center" }} />;
  if (isError) return <div>{(error as AxiosError)?.message}</div>;

  return (
    <div>
      {/* <Details
        title="REFERENCE FROM A PROFESSIONAL MEMBER OF THE INSTITUTE (Full Member or Fellow)"
        isOpen
      >
        <form onSubmit={formik.handleSubmit} className={styles.form}>
          <hr className={styles.hr} />
          <Field
            name="memberId"
            as={Input}
            label="Membership ID/Email of Referee"
          />
          <Field
            name="refereeFullName"
            as={Input}
            label="Referee's Full Name"
          />
          <Field
            name="refereeApprovalStatus"
            as={Input}
            label="Referee Approval Status"
          />
        </form>
      </Details> */}
      {profileUpload && (
        <Details title="COMPANY PROFILE" className={styles.details}>
        <hr className={styles.hr} />
        <br />
        <DownloadFile
          className={styles.input}
          title="Company's Profile Management Structure to determine the place of HRM"
          documentName={files.Profile ? files.Profile : "Company's Profile Management"}
          documentUrl={profileUpload?.FileUrl}
          otherAction={
            isProfileEditable ? (
              <label style={{cursor: updateDocumentMutation.isPending && currentFile === 'Profile' ? 'not-allowed' : 'pointer'}} className="changeFile">
                {updateDocumentMutation.isPending && currentFile === 'Profile' ? "Changing..." : "Change"}
                <input
                  type="file"
                  hidden
                  onChange={(e) => {
                    const file = e.target.files;
                    if (file) {
                      setFiles({...files, Profile: file[0]?.name});
                      setCurrentFile("Profile")
                      handleUpdate(file[0], UploadType.Profile)
                    }
                  }}
                />
              </label>
            ) : null
          }
        />
        <br/>
      </Details>
      )}
      {cac && (
        <Details title="CERTIFICATE OF INCORPORATION" className={styles.details}>
        <hr className={styles.hr} />
        <br />
        <DownloadFile
          className={styles.input}
          title="Certificate of Incorporation"
          documentName={files.CAC ? files.CAC : "Incorporation Certificate"}
          documentUrl={cac?.FileUrl}
          otherAction={
            isProfileEditable ? (
              <label  style={{cursor: updateDocumentMutation.isPending && currentFile === 'Cac' ? 'not-allowed' : 'pointer'}} className="changeFile">
                {updateDocumentMutation.isPending && currentFile === 'Cac' ? "Changing..." : "Change"}
                <input
                  type="file"
                  hidden
                  onChange={(e) => {
                    const file = e.target.files;
                    if (file) {
                      setFiles({...files, CAC: file[0]?.name});
                      setCurrentFile("Cac")
                      handleUpdate(file[0], UploadType.Cac)
                    }
                  }}
                />
              </label>
            ) : null
          }
        />
        <br/>
      </Details>
      )}
      {financial && (
        <Details
        title="CURRENT ANNUAL REPORT & FINANCIAL STATEMENT (If Applicable)"
        className={styles.details}
      >
        <hr className={styles.hr} />
        <br />
        <DownloadFile
          className={styles.input}
          title="Current Annual Report"
          documentName={files.Financial ? files.Financial : "Current Annual Report"}
          documentUrl={financial?.FileUrl}
          otherAction={
            isProfileEditable ? (
              <label style={{cursor: updateDocumentMutation.isPending && currentFile === 'Financial' ? 'not-allowed' : 'pointer'}} className="changeFile">
                {updateDocumentMutation.isPending && currentFile === 'Financial' ? "Changing..." : "Change"}
                <input
                  type="file"
                  hidden
                  onChange={(e) => {
                    const file = e.target.files;
                    if (file) {
                      setFiles({...files, Financial: file[0]?.name});
                      setCurrentFile("Financial")
                      handleUpdate(file[0], UploadType.Financial)
                    }
                  }}
                />
              </label>
            ) : null
          }
        />
        <br/>
      </Details>
      )}
    </div>
  );
};

export default DocumentUpload;
